import i18n from '../../../i18n';

export const PALETTE = ['#1880a1', '#2e7d32', '#f5a623', '#8e44ad', '#e74c3c', '#00acc1', '#6d4c41', '#546e7a', '#c0ca33', '#d81b60'];

export const formatInt = (value) => new Intl.NumberFormat(i18n.language === 'en' ? 'en-GB' : 'fr-FR').format(Number(value) || 0);
export const formatPercent = (value, digits = 1) => `${Number(value || 0).toFixed(digits)} %`;

const getCanonicalCountry = (country = '') => {
    const baseCountry = String(country).replace(/\s*\(.*?\)\s*/g, '').trim();
    const normalizedKey = baseCountry
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]/g, '');

    const aliases = {
        ivorycoast: "Cote d'Ivoire",
        cote_divoire: "Cote d'Ivoire",
        cotedivoire: "Cote d'Ivoire",
    };

    return { key: aliases[normalizedKey] || normalizedKey || 'inconnu', label: baseCountry || i18n.t('Inconnu') };
};

/** Regroupe les variantes d'un même pays (« Côte d'Ivoire », « Ivory Coast »…), trie par effectif et ajoute la part en %. */
export const mergeCountryDistribution = (countries = []) => {
    const grouped = countries.reduce((acc, item) => {
        const { key, label } = getCanonicalCountry(item?.country);
        const users = Number.parseInt(item?.users, 10) || 0;
        if (!acc[key]) acc[key] = { country: key === "Cote d'Ivoire" ? i18n.t("Cote d'Ivoire") : label, users: 0 };
        acc[key].users += users;
        return acc;
    }, {});

    const list = Object.values(grouped).sort((a, b) => b.users - a.users);
    const total = list.reduce((sum, item) => sum + item.users, 0);
    return list.map((item) => ({ ...item, share: total > 0 ? (item.users / total) * 100 : 0 }));
};
